// Predefined set of cache and stale times to use in `useQuery()`.

export type CacheTimeLength = 'long' | 'infinite';

const gcTime: Record<CacheTimeLength, number> = {
  long: 60 * 60 * 1000, // 60 minutes
  infinite: Infinity,
};
const staleTime: Record<CacheTimeLength, number> = {
  long: 15 * 60 * 1000, // 15 minutes
  infinite: Infinity,
};

export function getCacheTime(length: CacheTimeLength): {
  gcTime: number;
  staleTime: number;
} {
  return {
    gcTime: gcTime[length],
    staleTime: staleTime[length],
  };
}
